(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ticket-state', {
            parent: 'company_admin',
            url: '/ticket-state/:ticketType?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.ticketState.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/ticket-state/ticket-states.html',
                    controller: 'TicketStateController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', '$stateParams', function ($translate, $translatePartialLoader, $stateParams) {
                    $translatePartialLoader.addPart('ticketState');
                    $translatePartialLoader.addPart('ticketType');
                    $translatePartialLoader.addPart('ticketStateType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                ticketType: ['$stateParams', function($stateParams) {
                   return {
                       type: $stateParams.ticketType
                   };     
                }]
            }
        })        
        .state('ticket-state-detail', {
            parent: 'company_admin',
            url: '/ticket-state/{ticketType}/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.ticketState.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/ticket-state/ticket-state-detail.html',
                    controller: 'TicketStateDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketState');
                    $translatePartialLoader.addPart('ticketType');
                    $translatePartialLoader.addPart('ticketStateType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TicketState', function($stateParams, TicketState) {
                    return TicketState.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ticket-state',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }],
                ticketType: ['$stateParams', function($stateParams) {
                   return {
                       type: $stateParams.ticketType
                   };     
                }]
            }
        })
        .state('ticket-state-detail.edit', {
            parent: 'ticket-state-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/ticket-state/ticket-state-dialog.html',
                    controller: 'TicketStateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketState', function(TicketState) {
                            return TicketState.get({id : $stateParams.id}).$promise;
                        }],
                        ticketType: ['$stateParams', function($stateParams) {
                            return {
                                type: $stateParams.ticketType
                            };     
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-state.new', {
            parent: 'ticket-state',
            url: '/new/:ticketType',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/ticket-state/ticket-state-dialog.html',
                    controller: 'TicketStateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                listIndex: null,
                                ticketType: $stateParams.ticketType,
                                ticketStateType: null,
                                id: null
                            };
                        },
                        ticketType: ['$stateParams', function($stateParams) {
                            return {
                                type: $stateParams.ticketType
                            };     
                         }]
                    }
                }).result.then(function() {
                    $state.go('ticket-state', null, { reload: 'ticket-state' });
                }, function() {
                    $state.go('ticket-state');
                });
            }]
        })
        .state('ticket-state.edit', {
            parent: 'ticket-state',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/ticket-state/ticket-state-dialog.html',
                    controller: 'TicketStateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketState', function(TicketState) {
                            return TicketState.get({id : $stateParams.id}).$promise;
                        }],
                        ticketType: ['$stateParams', function($stateParams) {
                            return {
                                type: $stateParams.ticketType
                            };     
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-state', null, { reload: 'ticket-state' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-state.delete', {
            parent: 'ticket-state',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/ticket-state/ticket-state-delete-dialog.html',
                    controller: 'TicketStateDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TicketState', function(TicketState) {
                            return TicketState.get({id : $stateParams.id}).$promise;
                        }],
                        ticketType: ['$stateParams', function($stateParams) {
                            return {
                                type: $stateParams.ticketType
                            };     
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-state', null, { reload: 'ticket-state' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
